import React, { useEffect, useState } from 'react'
import styles from './index.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { getEventTools } from '../../../../../actions/classbook';

const TabPlan = ({ modalData, formData, subjectName, lessonEntry, setLessonEntry }) => {

    const dispatch = useDispatch();
    const { class_topic, event_tools } = useSelector(state => state.classbook);
    const [expandedNodes, setExpandedNodes] = useState([]);

    useEffect(() => {
        dispatch(getEventTools());
    }, []);

    useEffect(() => {
        if (class_topic?.length) {
            const quarterIds = class_topic
                .filter(item => item.prev_ref === -1)
                .map(item => item.oid);
            setExpandedNodes(quarterIds);
        }
    }, [class_topic]);

    const toggleQuarter = (oid, e) => {
        e.stopPropagation();
        setExpandedNodes(prev =>
            prev.includes(oid) ? prev.filter(n => n !== oid) : [...prev, oid]
        );
    };

    const selectTopic = (oid) => {
        setLessonEntry(prev => ({ ...prev, selectedTopic: prev.selectedTopic === oid ? null : oid }));
    };

    // рекурсивно собирает всех потомков узла в плоский массив
    const collectDescendants = (parentOid) => {
        const direct = class_topic?.filter(item => item.prev_ref === parentOid) || [];
        return direct.reduce((acc, child) => [...acc, child, ...collectDescendants(child.oid)], []);
    };

    const renderRows = () => {
        const quarters = class_topic?.filter(item => item.prev_ref === -1) || [];
        return quarters.map(quarter => {
            const isExpanded = expandedNodes.includes(quarter.oid);
            const descendants = collectDescendants(quarter.oid);

            return (
                <React.Fragment key={quarter.oid}>
                    {/* Строка четверти (depth 0) */}
                    <tr className={styles.rowQuarter}>
                        <td className={styles.tdTitle} colSpan={4}>
                            <span className={styles.titleCell}>
                                <span
                                    className={styles.expandIcon}
                                    onClick={e => toggleQuarter(quarter.oid, e)}
                                >
                                    {isExpanded ? '⊟' : '⊞'}
                                </span>
                                {quarter.title}
                            </span>
                        </td>
                    </tr>

                    {/* Все потомки плоским списком (depth 1) */}
                    {isExpanded && descendants.map(node => {
                        const isSelected = lessonEntry.selectedTopic === node.oid;
                        return (
                            <tr
                                key={node.oid}
                                className={isSelected ? styles.rowSelected : styles.row}
                                onClick={() => selectTopic(node.oid)}
                            >
                                <td className={styles.tdTitle}>
                                    <span style={{ paddingLeft: '20px' }} className={styles.titleCell}>
                                        <span className={styles.leafIcon}>└</span>
                                        {node.title}
                                    </span>
                                </td>
                                <td className={styles.tdNum}>{node.les_num || ''}</td>
                                <td className={styles.tdHours}>{node.hours || ''}</td>
                                <td className={styles.tdResults}>{node.planned_results || node.hw_text || ''}</td>
                            </tr>
                        );
                    })}
                </React.Fragment>
            );
        });
    };

    return (
        <div className={styles.wrapper}>
            {/* Шапка: Предмет + Тип + Дата */}
            <div className={styles.headerRow}>
                <div className={styles.headerLeft}>
                    <span className={styles.label}>Предмет</span>
                    <span className={styles.value}>
                        {subjectName}{modalData?.grpname ? `, класс — ${modalData.grpname}` : ''}
                    </span>
                </div>
                <div className={styles.headerRight}>
                    <label className={styles.label}>Тип занятия</label>
                    <select
                        className={styles.select}
                        value={lessonEntry.typeid}
                        onChange={e => setLessonEntry(prev => ({ ...prev, typeid: e.target.value }))}
                    >
                        <option value="">— не выбрано —</option>
                        {event_tools?.map(el => <option key={el.typeid} value={el.typeid}>{el.typename}</option>)}
                    </select>
                    <label className={styles.label} style={{ marginLeft: 24 }}>Дата по факту</label>
                    <input
                        type="date"
                        className={styles.dateInput}
                        value={lessonEntry.dateByFact}
                        onChange={e => setLessonEntry(prev => ({ ...prev, dateByFact: e.target.value }))}
                    />
                </div>
            </div>

            {/* Метка дерева */}
            <div className={styles.treeLabel}>Выберите тему занятия</div>

            {/* Дерево-таблица */}
            <div className={styles.treeWrapper}>
                <table className={styles.treeTable}>
                    <thead>
                        <tr>
                            <th className={styles.thTitle}>Содержание курса</th>
                            <th className={styles.thNum}>№ урока</th>
                            <th className={styles.thHours}>Кол-во часов</th>
                            <th className={styles.thResults}>Планируемые результаты</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderRows()}
                        {(!class_topic || class_topic.length === 0) && (
                            <tr><td colSpan={4} className={styles.noData}>Темы не загружены</td></tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Нижние поля */}
            <div className={styles.bottomRow}>
                <label className={styles.label}>Количество работ</label>
                <input
                    type="number"
                    min={0}
                    className={styles.numInput}
                    value={lessonEntry.amount}
                    onChange={e => setLessonEntry(prev => ({ ...prev, amount: Number(e.target.value) }))}
                />
                <label className={styles.label} style={{ marginLeft: 20 }}>Тестовое задание</label>
                <select className={styles.selectSm}>
                    <option value=""></option>
                </select>
                <label className={styles.label} style={{ marginLeft: 20 }}>Вес оценок по умолчанию</label>
                <select className={styles.selectSm}>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                </select>
            </div>

            <div className={styles.commentRow}>
                <label className={styles.label}>Комментарий</label>
                <input
                    type="text"
                    className={styles.commentInput}
                    value={lessonEntry.comment}
                    onChange={e => setLessonEntry(prev => ({ ...prev, comment: e.target.value }))}
                />
            </div>

            <div className={styles.totalRow}>
                <span>Итого по часам: <b>{class_topic?.reduce((s, n) => s + (Number(n.hours) || 0), 0) || 0}</b></span>
                <span style={{ marginLeft: 24 }}>Учебный план: <b>0</b></span>
            </div>
        </div>
    );
};

export default TabPlan;
